export default "__VITE_ASSET__C9i4b0tb__"